import { Landmark, Layers } from 'lucide-react'

interface SourceTypeBadgeProps {
  type: 'mewler' | 'pooled'
}

export function SourceTypeBadge({ type }: SourceTypeBadgeProps) {
  const isPooled = type === 'pooled'

  return (
    <span
      className={
        isPooled
          ? 'inline-flex items-center gap-1 rounded-full bg-green-500/20 px-1.5 py-0.5 font-medium text-[10px] text-green-400'
          : 'inline-flex items-center gap-1 rounded-full bg-purple-500/20 px-1.5 py-0.5 font-medium text-[10px] text-purple-400'
      }
    >
      {isPooled ? <Layers className="h-2.5 w-2.5" /> : <Landmark className="h-2.5 w-2.5" />}
      {isPooled ? 'Pooled' : 'Mewler'}
    </span>
  )
}
